import { Box, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { getRemoteText, getRemoteValue } from "../../Utils/firebase";
import { sendEvent } from "../../Utils/firebaseLogger";
import { FooterProps } from "./Footer";
import StoreButtons from "./StoreButtons";


const DesktopFooter = ({ handleWhatsAppClick, handleMailClick, handleCallCenterClick }: FooterProps) => {
  return (
    <Box
      sx={{
        bgcolor: "#101115",
        color: "white",
        zIndex: "9",
        position: "relative",
      }}
    >
      <Box sx={{ py: "44px", px: "8%" }}>
        <Stack
          flexDirection={"row"}
          flexWrap={"wrap"}
          justifyContent={"space-between"}
          columnGap={"32px"}
          rowGap={"32px"}
          maxWidth={"1160px"}
          mx={"auto"}
        >
          <Stack gap={3} maxWidth={"400px"}>
            {/* CRL-3241: kodi+ brand lockup (design footer__brand-lockup) */}
            <Link to="/">
              <Stack direction={"row"} alignItems={"center"} gap={"12px"}>
                <img
                  src={"/kodi-icon.svg"}
                  alt="kodi+"
                  style={{ width: "46px", height: "46px", borderRadius: "11px" }}
                />
                <Stack lineHeight={1.2}>
                  <Typography fontSize={"15px"} fontWeight={700} color={"#FFF"}>
                    {getRemoteText("brand_name", "kodi+")}
                  </Typography>
                  <Typography fontSize={"12px"} color={"rgba(255,255,255,.55)"}>
                    {getRemoteText("brand_by", "by Colendi")}
                  </Typography>
                </Stack>
              </Stack>
            </Link>
            <Typography
              variant="body2"
              fontSize={"14px"}
              fontWeight={400}
              color={"rgba(255,255,255,.85)"}
            >
              {getRemoteValue("footer_text")}
            </Typography>

            <StoreButtons />
          </Stack>
          <Stack rowGap={"14px"}>
            <Typography
              fontSize={"15px"}
              fontWeight={500}
              color={"rgba(255,255,255,.55)"}
              mb={"6px"}
            >
              {getRemoteValue("general")}
            </Typography>
            <Link
              to="/"
              color="inherit"
              style={{ fontSize: "14px", color: "rgba(255,255,255,.85)" }}
            >
              {getRemoteValue("debts")}
            </Link>
            <Link
              to="/sss"
              color="inherit"
              style={{ fontSize: "14px", color: "rgba(255,255,255,.85)" }}
              onClick={() => {
                sendEvent(`click_faq`, {});
              }}
            >
              {getRemoteValue("faq")}
            </Link>
          </Stack>
          <Stack rowGap={"16px"}>
            <Typography
              fontSize={"15px"}
              fontWeight={500}
              color={"rgba(255,255,255,.55)"}
              mb={"4px"}
            >
              {getRemoteValue("communication")}
            </Typography>

            <Stack sx={{ cursor: "pointer" }} onClick={handleCallCenterClick} display={"flex"} direction={"row"} alignItems={"center"}>
              <Stack mr={1}>
                <img
                  className="contact-icon"
                  src={"/icons/phone-icon-white.svg"}
                  alt=""
                />
              </Stack>
              <Typography variant="body2" fontSize={"14px"} color={"rgba(255,255,255,.85)"}>
                {getRemoteValue("colendi_info_callcenter_label")}
              </Typography>
            </Stack>

            <Stack sx={{ cursor: "pointer" }} onClick={handleWhatsAppClick} display={"flex"} direction={"row"} alignItems={"center"}>
              <Stack mr={1}>
                <img
                  className="contact-icon"
                  src={"/icons/whatsapp-icon-white.svg"}
                  alt=""
                />
              </Stack>
              <Typography variant="body2" fontSize={"14px"} color={"rgba(255,255,255,.85)"}>
                {getRemoteValue("colendi_info_whatsapp_label")}
              </Typography>
            </Stack>

            <Stack sx={{ cursor: "pointer" }} onClick={handleMailClick} display={"flex"} direction={"row"} alignItems={"center"}>
              <Stack mr={1}>
                <img
                  className="contact-icon"
                  src={"/icons/mail-icon-white.svg"}
                  alt=""
                />
              </Stack>
              <Typography variant="body2" fontSize={"14px"} color={"rgba(255,255,255,.85)"}>
                {getRemoteValue("colendi_info_mail")}
              </Typography>
            </Stack>

            <Stack display={"flex"} direction={"row"} alignItems={"start"}>
              <img
                src={"/icons/location-icon-white.svg"}
                alt=""
                style={{ marginRight: "8px", marginTop: "2px" }}
              />
              <Typography
                variant="body2"
                fontSize={"14px"}
                maxWidth={"250px"}
                color={"rgba(255,255,255,.85)"}
              >
                {getRemoteValue("colendi_adress")}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Box>
      {/* CRL-3241: simple bordered copyright strip (design footer__legal) */}
      <Box
        sx={{
          borderTop: "1px solid rgba(255,255,255,.08)",
          py: "17px",
          textAlign: "center",
        }}
      >
        <Typography fontSize={"13px"} color={"rgba(255,255,255,.45)"}>
          {getRemoteText("footer_by_colendi", "2026 © kodi+ · by Colendi")}
        </Typography>
      </Box>
    </Box>
  );
};

export default DesktopFooter;
